import React, { useEffect, useState } from 'react';
import { Button, Card, message, Space } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { SaveOutlined, SisternodeOutlined } from '@ant-design/icons';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var ClassRoundSource = models.rounds.ClassRoundSource;
import { SortableList, SortableListItem } from '../../../../components/SortableList';
export const RoundMatchRace = (props) => {
    const { round, disabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [matches, setMatches] = useState([]);
    const [sortedList, setSortedList] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "generate-matchrace-permutations")
            .then((result) => {
            setIsLoading(false);
            const newMatches = result.map((a) => {
                const heatsTeamIds = Object.keys(a);
                const idAttribute = heatsTeamIds[0] + '-' + heatsTeamIds[1];
                return ({
                    ...a,
                    match: idAttribute
                });
            });
            setSortedList(newMatches);
            setMatches(newMatches);
        }).catch((err) => {
            message.error(err.message);
            setIsLoading(false);
        });
    }, [round]);
    const onSorted = (list) => {
        setSortedList(list);
    };
    const onSave = () => {
        setIsSaving(true);
        const createMatches = sortedList.map((a) => {
            delete a.match;
            return a;
        });
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "create-matchrace", createMatches)
            .then(() => {
            setIsSaving(false);
        }).catch((err) => {
            message.error(err.message);
            setIsSaving(false);
        });
    };
    const renderItem = (item, index) => {
        const teamStartNumbers = Object.values(item);
        return (React.createElement(SortableListItem, { item: item, idAttribute: 'match', title: `${teamStartNumbers[0]} - ${teamStartNumbers[1]}`, disabled: disabled }));
    };
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(SisternodeOutlined, null),
            " ",
            _T('round.matchrace')), style: { height: '100%' } },
        React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
            React.createElement(SortableList, { contextId: 'matches', loading: isLoading, items: matches, idAttribute: 'match', renderItem: renderItem, onSorted: onSorted, footer: undefined, disabled: disabled }),
            React.createElement(Button, { type: "primary", onClick: onSave, icon: React.createElement(SaveOutlined, null), loading: isSaving, disabled: disabled }, _T('common.save')))));
};
